import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';

import type { Recording } from '../types';
import { ShareButton } from './ShareButton';
import { StickerShareButton } from './StickerRelated/StickerShareButton';
import { StickerCreateHighlightButton } from './StickerRelated/StickerCreateHighlightButton';

const SubContainer = styled.div`
  background-color: ${tokens.color.ui_background};
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 6px;
  border-radius: ${tokens.spacer.x0};
  ${tokens.elevation(4)}
`;

const Container = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: ${tokens.spacer.x0};
  border-radius: ${tokens.spacer.x0};
`;

interface Props {
  onShare: (recording: Recording, startAt?: boolean, startAtTime?: number) => void;
  onCreate: () => void;
  showStickerLabels: boolean;
}

export const RelevantActionNotificationContent = ({
  onCreate,
  onShare,
  showStickerLabels,
}: Props): JSX.Element => {
  if (showStickerLabels) {
    return (
      <Container>
        <SubContainer>
          <StickerShareButton onClick={onShare} />
          <StickerCreateHighlightButton onClick={onCreate} />
        </SubContainer>
      </Container>
    );
  }

  return (
    <div
      css={css`
        box-shadow: 0 0 12px 2px rgba(0, 0, 0, 0.4);
        background-color: ${tokens.color.neutral_700};
        display: flex;
      `}
    >
      <ShareButton onClick={onShare} />
    </div>
  );
};
